var _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgClock = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .clock-icon {\n        clip-path: url(#clip-Clock_1);\n      }\n\n      .clock-color {\n        fill: #09819A;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Clock_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clock_1",
    "data-name": "Clock \\u2013 1",
    className: "clock-icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_schedule_24px",
    className: "clock-color",
    d: "M25.976,2A24,24,0,1,0,50,26,23.988,23.988,0,0,0,25.976,2ZM26,45.2A19.2,19.2,0,1,1,45.2,26,19.195,19.195,0,0,1,26,45.2ZM27.2,14H23.6V28.4l12.6,7.56L38,33.008,27.2,26.6Z",
    transform: "translate(-2 -2)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClock, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/clock.702e4e40.svg";
export { ForwardRef as ReactComponent };